module.exports = __webpack_public_path__ + "img/bg.87873f42.png";